import { render, staticRenderFns } from "./assetsTotal.vue?vue&type=template&id=35e30b3d"
import script from "./assetsTotal.vue?vue&type=script&lang=js"
export * from "./assetsTotal.vue?vue&type=script&lang=js"
import style0 from "./assetsTotal.vue?vue&type=style&index=0&id=35e30b3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports